module.exports = __webpack_public_path__ + "static/tsconfig-ref-a95a84074eb107d1ad44cbed3b174b0f.png";